// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"3af507ae","353":"ba3c5908"}[chunkId] + ".js";
};